import React, {useState} from "react";
// import styles from "./style/answer_common.module.css";
import styles from "./style/answer_dropdown.module.css";
import { useLanguage } from '../../functions/setGetLanguage';

const Answer_dropdown = ({ choices, FunctionOnClick }) => {
  const { language } = useLanguage();

  const [dropdown, setDropdown] = useState(false);

  const ToggleDropdown = () => {
    setDropdown(!dropdown);
  };

  return (
    <div className={styles.choices}>
      <div className={`${styles.options} ${dropdown === true ? styles.activeDropdown : ""}`}>
        {choices.map((choice, i) => (
          <button
            key={i}
            className={styles.choiceDropdown}
            onClick={() => FunctionOnClick(choice)}
          >
            {choice[`text${language}`]}
          </button>
        ))}
      </div>
      <input onClick={() => ToggleDropdown()} className={styles.inputDropdown} readOnly autoComplete="off" placeholder="Open Dropdown Menu."/>
    </div>
  );
};

export default Answer_dropdown;
